import { useQueryWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { QueryKey, UseQueryOptions } from 'react-query';
import http from '../config/http-service';
import type { Paginated, RestaurantInquiryEvent } from './types';
import { restaurantInquiriesEndpoint } from './use-create-restaurant-inquiry-api';

// GET api/v1/cms/restaurant-inquiries/:id/history — paginated audit timeline
// (createdAt DESC): header + item status changes and assignment events.
// Entries are append-only and immutable, so caching by id is safe.
type TData = Paginated<RestaurantInquiryEvent>;
type TError = AxiosError;
type Options = Omit<UseQueryOptions<TData, TError, TData, QueryKey>, 'queryKey' | 'queryFn'>;

export function useGetRestaurantInquiryHistoryApi(
  id: number | string | undefined,
  page = 1,
  limit = 20,
  options?: Options
) {
  return useQueryWrapper<TData, TError>(
    [restaurantInquiriesEndpoint, 'history', id, { page, limit }],
    async () => {
      const response = await http.get(`${restaurantInquiriesEndpoint}/${id}/history`, { params: { page, limit } });
      return response.data;
    },
    { enabled: id !== undefined && id !== null && id !== '', keepPreviousData: true, ...options }
  );
}
